module.exports = __webpack_public_path__ + "img/schedule.67e06abe.svg";